import { defineStore } from "pinia";

export const useProfile = defineStore("profile", () => {
  const profile = ref<any>({});
  const isFetching = ref(false);

  const isVip = computed(() => profile.value?.VIP);
  const hasChildren = computed(() => profile.value?.children?.length > 0);

  const fetchProfile = async (newProfile: any = {}) => {
    const isProfileEmpty = Object.keys(profile.value).length === 0;
    const isNewProfileDifferent =
      JSON.stringify(profile.value) !== JSON.stringify(newProfile);

    if ((!isProfileEmpty && !isNewProfileDifferent) || isFetching.value) {
      return;
    }

    isFetching.value = true;
    const { signOut } = useAuth();

    try {
      const { data } = await useFetch("/api/profile");
      profile.value = data.value;
    } catch (e) {
      await signOut({ callbackUrl: "/" });
      console.error("Error fetching profile:", e);
    } finally {
      isFetching.value = false;
    }
  };

  const getProfile = async () => {
    if (!profile.value || Object.keys(profile.value).length === 0) {
      await fetchProfile();
    }
    return profile.value;
  };

  return {
    profile,
    isFetching,
    isVip,
    hasChildren,
    fetchProfile,
    getProfile,
  };
});
